import EditIcon from '@mui/icons-material/Edit';

export const EditTimeTrackingIcon = EditIcon;
